import styled, { css } from 'styled-components';

import { Box } from '@/components/Box';
import { NextImage } from '@/components/NextImage';

export const FinancingContainer = styled(Box)`
  width: 100%;
  ${({ theme }) =>
    css`
      margin-bottom: ${theme.spacing(2)};
      margin-left: -${theme.spacing(1)};
      font-family: ${theme.fontFamilies.openSans};
      font-size: ${theme.fontSizes.p2};
      line-height: ${theme.spacing(2.75)};
      > * {
        margin-left: ${theme.spacing(1)};
      }
      padding: ${theme.spacing(0, 4)};
      line-height: ${theme.spacing(4)};
      ${theme.media.md.up} {
        width: 380px;
        display: flex;
        align-items: center;
        flex-direction: row;
        justify-content: center;
        flex-wrap: wrap;
        justify-content: flex-start;
        padding: ${theme.spacing(0)};
      }
    `}
`;

export const StyledLink = styled.span`
  ${({ theme }) =>
    css`
      text-decoration: underline;
      cursor: pointer;
      color: ${theme.colors.primaryBlue};
      font-weight: ${theme.fontWeights.bold};
      font-family: ${theme.fontFamilies.openSans};
      font-size: ${theme.fontSizes.p2};
      color: ${theme.colors.primaryBlue};
      display: block;
      ${theme.media.md.up} {
        display: inline;
      }
    `}
`;

export const Image = styled(NextImage)`
  vertical-align: middle;
`;
